/* eslint-disable newline-per-chained-call */
import React, { useEffect, useState } from "react";
import CandidateInfoCard from "./CandidateInfoCard";
import { Avatar, Button, Divider, Flex, Select, Spin, Tooltip, Typography } from "antd";
import { SvgIcons } from "Icon/SvgIcons";
import SkillsList from "components/CandidateCard/SkillsLIst";
import AllEducation from "./AllEducation";
import verifiedtick from "../../images/verifiedtick.svg";
import { getCandidate } from "api/candidate.api";
import Certificates from "components/TalentPools/Candidates/Certificates";
import WebSearch from "./WebSearch";
import CandidateNote from "./CandidateNote";

import SendBulkEmail from "./SendBulkEmail";
import { useFeatureAllowedFromState } from "services/CustomeHooks";

import { useDispatch, useSelector } from "react-redux";

import { creditsRefreshChanger } from "store/slices/refresh.slice";
import { FEATURE_CONSTANTS } from "components/constants/AppConstants";
import CandidateBioComponent from "components/TalentPools/CandidateBioComponent";
import { replaceReduxCandidates } from "store/slices/candidateBulkMail.slice";
import { icons } from "components/TalentPools/TalentPoolCandidateNameAndImage";
import { readUser } from "services/localStorage.service";
import UploadedFiles from "./UploadedFiles";
import TooltipWrapper from "./TooltipWrapper";
import FIlesWithName from "./WithNameFiles";
import { isLinkedInOrDoximity } from "utils/utils";
import { DoximityIconCompoGray } from "Icon/Icon";

const AllExperiences = React.lazy(() => import("./AllExperiences"));
const { Paragraph } = Typography;
interface CandidateProfileProps {
  clickedProfile?: number | null;
  open: boolean;
  isUserProject?: boolean;
  configs?: any;
  isContactInfoNotAllowed?: boolean;
  isBioNotAllowed?: boolean;
}

const { Text } = Typography;

const CandidateProfile: React.FC<CandidateProfileProps> = ({
  clickedProfile,
  open,
  isUserProject,
  configs,
  isContactInfoNotAllowed,
  isBioNotAllowed,
}) => {
  const userData = useSelector((state: any) => state.user.user);
  const [candidateData, setCandidateData] = useState<any>(null);
  const [candidateNotes, setCandidateNotes] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const skills = candidateData?.skills || [];
  const [refresh, setRefresh] = useState<boolean>(false);
  const isFeatureAllowed = useFeatureAllowedFromState(FEATURE_CONSTANTS.FCPV);
  const isMailFeatureAllowed = useFeatureAllowedFromState(FEATURE_CONSTANTS.FCEI);
  const [orderedEmails, setOrderedEmails] = useState<any>([]);
  const [isBioEdited, setIsBioEdited] = useState<boolean>(false);

  const dispatch = useDispatch();
  const getUserInfo = readUser();
  function parseValue(values: string[], fallbackKey: string, candidateData: any) {
    if (values.length > 0) {
      try {
        return JSON.parse(values[0]);
      } catch {
        return values[0];
      }
    }

    if (candidateData?.[fallbackKey]) {
      return candidateData[fallbackKey];
    }

    return "";
  }
  const getCandidateById = async () => {
    if (typeof clickedProfile === "number") {
      setLoading(true);
      setError(null);
      try {
        const data = await getCandidate(clickedProfile);
        setCandidateData(data?.full_profile);
        setCandidateNotes(data?.notes);
      } catch (err) {
        setError("Failed to load candidate data");
      } finally {
        setLoading(false);
        dispatch(creditsRefreshChanger());
      }
    }
  };

  const isEmailDisabled = () => {
    return !userData.user?.email_enabled || !isMailFeatureAllowed;
  };

  // const emailOptions =
  //   candidateData?.emails?.map((email: string) => ({ value: email, label: email })) || [];
  // const phoneOptions =
  //   candidateData?.phone_numbers?.map((phone: string) => ({ value: phone, label: phone })) || [];

  const handleCandidateSelect = () => {
    dispatch(
      replaceReduxCandidates([
        {
          id: clickedProfile ? clickedProfile : 0,
          name: candidateData.full_name,
          email: candidateData.emails,
          profile: candidateData.profile_pic_url,
          location: candidateData.location,
          jobTitle: candidateData.title,
          graphProfileId: candidateData.graph_profile_id,
        },
      ])
    );
  };

  const getATSIcon = (key: string) => {
    if (key === "SENT_TO_SMARTRECRUITERS") {
      return candidateData.tags[key] ? icons["SMART_RECRUITER"] : icons["SMART_RECRUITER_ERROR"];
    } else if (key === "SENT_TO_GREENHOUSE") {
      return candidateData.tags[key] ? icons["GREENHOUSE"] : icons["GREENHOUSE_ERROR"];
    }
  };

  const getATSTitle = (key: string) => {
    if (key === "SENT_TO_SMARTRECRUITERS") {
      return "Smart Recruiters";
    } else if (key === "SENT_TO_GREENHOUSE") {
      return "Greenhouse";
    }
  };

  useEffect(() => {
    if (clickedProfile && isFeatureAllowed && open) {
      getCandidateById();
    }
  }, [clickedProfile]);

  useEffect(() => {
    if (clickedProfile && isFeatureAllowed && open && refresh) {
      getCandidateById();
      setRefresh(false);
    }
  }, [refresh]);

  useEffect(() => {
    if (candidateData) {
      handleCandidateSelect();
    }
  }, [candidateData]);

  const handleSetDocument = () => {
    if (!candidateNotes) return [];
    const value = candidateNotes.flatMap((note: any) => {
      if (!note?.document || !note.custom_fields?.name) return [];
      return [
        {
          ...note.custom_fields,
          noteId: note.id,
          userId: note.user.id,
          url: note.document,
        },
      ];
    });
    return value;
  };

  const getEditedField = (key: string, fallbackKey: string) => {
    // const values = candidateNotes?.map((note: any) => note.custom_fields?.[key]).filter(Boolean) || [];
    const values =
      candidateNotes
        ?.map((note: any) => note.custom_fields?.[key])
        .filter((val: any) => key === "document" || Boolean(val)) || [];
    if (key === "bio") {
      return parseValue(values, fallbackKey, candidateData);
    }

    return values.length > 0
      ? values[0]
      : candidateData?.[fallbackKey] ||
      (key === "work_experience" ? [] : "") ||
      (key === "education_experience" ? [] : "") ||
      (key === "emails" ? [] : "") ||
      (key === "phone_numbers" ? [] : "") ||
      (key === "other_profiles_urls" ? [] : "");
  };

  const getEditedWorkEducationField = (key: string, fallbackKey: string) => {
    const values =
      candidateNotes?.map((note: any) => note.custom_fields?.[key]).filter(Boolean) || [];
    return values.length > 0
      ? values.flatMap((group: any) =>
        group.flatMap((item: any) => item.education_experience || [])
      )
      : candidateData?.[fallbackKey] ||
      (key === "work_experience" ? [] : "") ||
      (key === "education_experience" ? [] : "");
  };

  // Usage
  const editedDisplayName = getEditedField("display_name", "full_name");
  const editedJobTitle = getEditedField("title", "title");
  const editedLocation = getEditedField("location", "location");
  const editedDescription = getEditedField("bio", "bio");
  const editedExperience = getEditedField("work_experience", "work_experience");
  const editedDocument = handleSetDocument();
  const editedOtherProfilesUrls = getEditedField("other_profiles_urls", "other_profiles_urls");

  const editedEducation = getEditedWorkEducationField(
    "education_experience",
    "education_experience"
  );
  // const getEducationExperience = [
  //   candidateData?.education_experience[0] ?? [],
  //   ...(editedEducation ?? [])
  // ];

  const mergedEducation = [
    ...(candidateData?.education_experience ?? []),
    ...(editedEducation ?? []),
  ];

  const seen = new Set();
  const getEducationExperience = mergedEducation.filter((edu) => {
    const uniqueKey = JSON.stringify({
      school: edu?.school_name?.toLowerCase()?.trim(),
      degree: edu?.degree?.toLowerCase()?.trim(),
      start: edu?.start_date,
      end: edu?.end_date,
    });

    if (seen.has(uniqueKey)) return false;
    seen.add(uniqueKey);
    return true;
  });

  const [tooltips, setTooltips] = useState({
    name: "",
    title: "",
    location: "",
    emails: "",
    phones: "",
    other_profiles_urls: "",
    bio: "",
    experience: "",
    education_experience: "",
    web_search: "",
    document: "",
    note: "",
  });

  useEffect(() => {
    if (!candidateNotes) return; // Ensure candidateNotes is not null or undefined

    const recentlyModified = candidateNotes
      // .filter((item: any) => item?.custom_fields?.is_edited)
      .sort(
        (a: any, b: any) =>
          new Date(b?.custom_fields?.modified_date).getTime() -
          new Date(a?.custom_fields?.modified_date).getTime()
      );

    if (recentlyModified.length === 0) return; // No modifications found

    const fields = [
      { key: "display_name", stateKey: "name" },
      { key: "title", stateKey: "title" },
      { key: "location", stateKey: "location" },
      { key: "emails", stateKey: "emails" },
      { key: "phone_numbers", stateKey: "phones" },
      { key: "other_profiles_urls", stateKey: "other_profiles_urls" },
      { key: "bio", stateKey: "bio" },
      { key: "work_experience", stateKey: "experience" },
      { key: "education_experience", stateKey: "education_experience" },
      { key: "web_search", stateKey: "web_search" },
      { key: "document", stateKey: "document" },
      { key: "note", stateKey: "note" },
    ];

    const newTooltips: any = { ...tooltips };

    fields.forEach(({ key, stateKey }) => {
      const item = recentlyModified.find((note: any) => note?.custom_fields?.[key]);
      if (item) {
        if (item.custom_fields?.modified_date) {
          const date = new Date(item.custom_fields?.modified_date).toISOString().split("T")[0];
          newTooltips[stateKey] = `${item.custom_fields.is_edited ? "Edited" : "Added"} by ${item.custom_fields.edited_by
            } on ${date}`;
        }
      }
    });
    console.log("New Tooltips: ", newTooltips);
    setTooltips(newTooltips);
  }, [candidateNotes]);

  const emailOptions =
    candidateData?.emails
      ?.slice() // copy to avoid mutating original
      .reverse() // latest added at top
      .map((email: string) => {
        return {
          value: email,
          label: email,
        };
      }) || [];

  const phoneOptions =
    candidateData?.phone_numbers
      ?.slice() // copy to avoid mutating original
      .reverse() // latest added at top
      .map((phone: string) => {
        return {
          value: phone,
          label: phone,
        };
      }) || [];

  useEffect(() => {
    if (emailOptions) {
      setOrderedEmails(emailOptions);
    }

    const bioValues = candidateNotes
      ?.map((note: any) => note.custom_fields?.["bio"])
      .filter((val: any) => val !== undefined);

    if (bioValues?.length > 0) {
      setIsBioEdited(true);
    } else {
      setIsBioEdited(false);
    }
  }, [candidateNotes]);

  const otherProfilesUrlsOptions =
    editedOtherProfilesUrls?.map((url: string) => ({ value: url, label: url })) || [];

  const getProfileIcon = (url: string) => {
    const domain = isLinkedInOrDoximity(url);
    if (domain === "linkedin") {
      return React.cloneElement(SvgIcons.linkedinSvg, { className: "w-6 h-6" });
    } else if (domain === "doximity") {
      return <DoximityIconCompoGray />;
    }
  };

  if (error) return <p>{error}</p>;

  return (
    <Spin spinning={loading}>
      <div>
        <CandidateInfoCard
          candidateNotes={candidateNotes}
          // name={candidateData?.full_name}
          name={editedDisplayName}
          profilePic={candidateData?.profile_pic_url}
          // location={candidateData?.location}
          // title={candidateData?.title}
          location={editedLocation}
          title={editedJobTitle}
          workExperience={candidateData?.work_experience}
          licenses={candidateData?.licenses}
          npi={candidateData?.npi}
          editedTooltip={true}
          toolTipText={{
            display_name: tooltips.name,
            location: tooltips.location,
            title: tooltips.title,
          }}
        />

        <Divider
          style={{
            margin: "12px 0",
          }}
        />
        {!isContactInfoNotAllowed && (
          <>
            <Flex align="center" justify="space-between">
              {emailOptions.length > 0 || phoneOptions.length > 0 ? (
                <Flex>
                  <TooltipWrapper text={tooltips.emails} placement="top">
                    {emailOptions.length > 0 && (
                      <Flex align="center">
                        <Avatar
                          size={32}
                          icon={SvgIcons.mailSvg}
                          style={{ backgroundColor: "#F2F4F7", height: "32px", width: "32px" }}
                        />
                        <Select
                          defaultValue={emailOptions.length > 0 ? emailOptions[0].value : undefined}
                          value={emailOptions[0].value}
                          style={{ fontSize: "12px", fontWeight: 500, color: "#6941C6" }}
                          variant="borderless"
                          options={emailOptions}
                        />
                      </Flex>
                    )}
                  </TooltipWrapper>
                  <TooltipWrapper text={tooltips.phones} placement="top">
                    {phoneOptions.length > 0 && (
                      <Flex align="center">
                        <Avatar
                          size={32}
                          icon={SvgIcons.phoneSvg}
                          style={{ backgroundColor: "#F2F4F7", height: "32px", width: "32px" }}
                        />
                        <Select
                          defaultValue={phoneOptions.length > 0 ? phoneOptions[0].value : undefined}
                          value={phoneOptions[0].value}
                          style={{ fontSize: "12px", fontWeight: 500, color: "#6941C6" }}
                          variant="borderless"
                          options={phoneOptions}
                        />
                      </Flex>
                    )}
                  </TooltipWrapper>
                </Flex>
              ) : (
                <Flex justify="center" align="center" className="mb-2">
                  <Flex vertical className="mt-2 mx-2">
                    <Text className="block">No contact found</Text>
                  </Flex>
                </Flex>
              )}
              <Flex className="self-end">
                <div className="flex  gap-2.5 justify-center">
                  {/* <button className="relative">{SvgIcons.whatsappSvg}</button>
          <button className="relative">{SvgIcons.slackSvg}</button> */}
                  {candidateData?.profile_url && (
                    <a
                      className="relative"
                      href={candidateData?.profile_url}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {getProfileIcon(candidateData?.profile_url)}
                    </a>
                  )}
                  {/* {candidateData?.other_profiles_urls[0] && ( */}
                  {/* {editedOtherProfilesUrls[0] && (
                    <a
                      className="relative"
                      // href={candidateData?.other_profiles_urls[0]}
                      href={editedOtherProfilesUrls[0]}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {React.cloneElement(SvgIcons.linkedinSvg, { className: "w-6 h-6" })}
                    </a>
                  )} */}
                  {emailOptions.length > 0 && getUserInfo.role !== "EXTERNAL_CONTRIBUTOR" && (
                    <SendBulkEmail
                      customButton={
                        <Tooltip
                          title={
                            <span className="flex items-center gap-x-1">
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M8.74928 11.2501L17.4993 2.50014M8.85559 11.5235L11.0457 17.1552C11.2386 17.6513 11.3351 17.8994 11.4741 17.9718C11.5946 18.0346 11.7381 18.0347 11.8587 17.972C11.9978 17.8998 12.0946 17.6518 12.2881 17.1559L17.78 3.08281C17.9547 2.63516 18.0421 2.41133 17.9943 2.26831C17.9528 2.1441 17.8553 2.04663 17.7311 2.00514C17.5881 1.95736 17.3643 2.0447 16.9166 2.21939L2.84349 7.71134C2.34759 7.90486 2.09965 8.00163 2.02739 8.14071C1.96475 8.26129 1.96483 8.40483 2.02761 8.52533C2.10004 8.66433 2.3481 8.7608 2.84422 8.95373L8.47589 11.1438C8.5766 11.183 8.62695 11.2026 8.66935 11.2328C8.70693 11.2596 8.7398 11.2925 8.7666 11.3301C8.79685 11.3725 8.81643 11.4228 8.85559 11.5235Z"
                                  stroke="white"
                                  strokeWidth="1.66667"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>{" "}
                              Send Email
                            </span>
                          }
                          placement="top"
                          overlayClassName="custom-tooltip"
                        >
                          <button
                            // href={undefined}
                            // target="_blank"
                            // rel="noreferrer"

                            className="relative"
                            onClick={(e) => {
                              e.preventDefault(); // Prevents the default navigation
                            }}
                          >
                            {React.cloneElement(SvgIcons.mailBigSvg, { className: "w-6 h-6" })}
                            <img
                              src={verifiedtick}
                              className="absolute w-2.5 h-2.5 top-0 right-[-4px]"
                            />
                          </button>
                        </Tooltip>
                      }
                      profileData={candidateData}
                      autoGenerate={true}
                      // emails={candidateData && candidateData.emails ? candidateData.emails : []}
                      emails={candidateData && orderedEmails ? orderedEmails : []}
                      profileId={candidateData?.graph_profile_id}
                      candidateId={candidateData}
                    ></SendBulkEmail>
                  )}
                  {candidateData &&
                    Object.keys(candidateData?.tags)
                      .filter((tag) => tag !== "ADDED_TO_TALENT_POOL")
                      .map((key) => {
                        return (
                          ["SENT_TO_SMARTRECRUITERS", "SENT_TO_GREENHOUSE"].includes(key) && (
                            <Button
                              type="link"
                              icon={getATSIcon(key)}
                              title={getATSTitle(key)}
                              className="gray-gray-9"
                            ></Button>
                          )
                        );
                      })}
                  {/* <button className="w-5 h-5 rounded-full border border-main-border flex justify-center items-center">
                {SvgIcons.plusSvg}
              </button> */}
                </div>
              </Flex>
            </Flex>
            <Divider
              style={{
                margin: "12px 0",
              }}
            />
          </>
        )}
        <Flex className="mt-6 p-[6px]">
          <SkillsList skills={skills} topMargin={false}></SkillsList>
        </Flex>
        <Divider
          style={{
            margin: "12px 0",
          }}
        />
        {editedDocument && editedDocument.length > 0 ? (
          <>
            {" "}
            <Flex justify="space-between" align="center">
              <div className="py-2 px-[6px] border-b border-dashed" style={{ width: "100%" }}>
                <Flex align="center" className="w-full">
                  <TooltipWrapper text={tooltips.document} placement="right">
                    <div className="text-text-heading font-bold pr-2.5 text-base text-sm">
                      Uploaded Files:
                    </div>
                  </TooltipWrapper>
                </Flex>
              </div>
            </Flex>
            <Flex gap={20} wrap="wrap" className="my-5">
              {editedDocument && editedDocument.length > 0 ? (
                editedDocument?.map((document: any, index: number) => (
                  <FIlesWithName
                    key={index}
                    document={document}
                  // handleDelete={() => showConfirmNote(document.noteId, clickedProfile, "document")}
                  // handleEdit={() => {
                  //   setSelectedDocument(document);
                  //   setIsEditingDocuments(true);
                  // }}
                  />
                ))
              ) : (
                <Flex justify="center" align="center" className="mb-2">
                  <Flex vertical className="mt-2 mx-2">
                    <Text className="block">No documents found</Text>
                  </Flex>
                </Flex>
              )}
            </Flex>
          </>
        ) : null}

        {candidateNotes && <UploadedFiles candidateNotes={candidateNotes}></UploadedFiles>}
        {clickedProfile && (
          // <CandidateBioComponent id={clickedProfile} bio={candidateData?.bio} isProfile={true} />
          <CandidateBioComponent
            id={clickedProfile}
            isBioEdited={isBioEdited}
            bio={editedDescription}
            isProfile={true}
            candidateNotes={candidateNotes}
            tooltipText={tooltips.bio}
          />
        )}
        <div className="mt-6">
          <AllExperiences
            totalExperience={candidateData?.total_experience_str || "0"}
            // workExperience={candidateData?.work_experience ?? []}
            workExperience={editedExperience ?? []}
            tooltipText={tooltips.experience}
            currentRoleDuration={candidateData?.duration_in_job_str}
          />
        </div>
        <React.Suspense fallback={<Spin />}>
          {candidateData?.intern_and_volunteer_experience?.length > 0 && (
            <div className="mt-6">
              <AllExperiences
                totalExperience={candidateData?.total_experience || 0}
                isInternship={true}
                workExperience={candidateData?.intern_and_volunteer_experience ?? []}
              />
            </div>
          )}
        </React.Suspense>
        <div className="mt-6">
          {/* <AllEducation education={candidateData?.education_experience ?? []} /> */}
          {/* <AllEducation education={getEducationExperience ?? []} /> */}
          <AllEducation
            education={getEducationExperience ?? []}
            clickedProfile={clickedProfile!}
            editorName={userData?.first_name}
            setRefresh={setRefresh}
            loading={loading}
            setError={setError}
            tooltipText={tooltips.education_experience}
          />
        </div>

        {clickedProfile && (
          <div className="mt-6">
            {/* <WebSearch clickedProfile={clickedProfile} isEditedWebSearch={false} editorName={userData?.first_name} setRefresh={setLoading} loading={loading} setError={setError} candidateNotes={candidateNotes} /> */}
            <WebSearch
              clickedProfile={clickedProfile}
              isEditedWebSearch={false}
              editorName={userData?.first_name}
              setRefresh={setRefresh}
              loading={loading}
              setError={setError}
              candidateNotes={candidateNotes}
              tooltipText={tooltips.web_search}
            />
          </div>
        )}

        <div className="mt-6">
          {candidateData?.certifications?.length > 0 && (
            <Certificates certificates={candidateData?.certifications} />
          )}
        </div>
        {clickedProfile && (
          <div className="mt-6">
            {/* <CandidateNote candidateId={clickedProfile} Notes={candidateNotes} editorName={userData?.first_name} /> */}
            <CandidateNote
              editorName={userData?.first_name}
              candidateId={clickedProfile}
              Notes={candidateNotes}
              setRefresh={setRefresh}
              loading={loading}
              setError={setError}
            />
          </div>
        )}
      </div>
    </Spin>
  );
};

export default React.memo(CandidateProfile);
